import { useContext } from "react";

import { SidebarContext, type SidebarContextValue } from "./SidebarContext";

export const useSidebar = (): SidebarContextValue => {
  const context = useContext(SidebarContext);
  if (context === null) {
    throw new Error("useSidebar must be used within SidebarProvider");
  }
  return context;
};
